var accomodationReservation = {
  options: {
    ajax_url: sikmoVars.ajax_url,
    doing_ajax: false,
  },

  selectors: {
    button_submit: '.js-accomodation-reservation-button-submit',

    error: '.js-accomodation-reservation-error',

    input_id: '.js-accomodation-reservation-input-id',
    input_date_from: '.js-accomodation-reservation-input-date-from',
    input_date_to: '.js-accomodation-reservation-input-date-to',
    input_term_select: '.js-accomodation-reservation-input-term-select',
    input_persons: '.js-accomodation-reservation-input-persons',

    count_box: '.js-accomodation-reservation-count-box',
    count_box_price_list: '.js-accomodation-reservation-price-list',
    count_box_price_total: '.js-accomodation-reservation-price-total',
  },

  init: function () {
    const self = this;

    self.loadFunctionInside();
  },

  loadFunctionInside: function () {
    const self = this;

    //Events
    //Submit
    jQuery(self.selectors.button_submit).on("click", function (event) {
      event.preventDefault();
      self.submit();
    });

    //Inputs changed
    jQuery(self.selectors.input_persons + ", " + self.selectors.input_date_from + ", " + self.selectors.input_date_to + ", " + self.selectors.input_term_select).on("input change", function (event) {
      event.preventDefault();
      self.boxReCalc();
    });
  },

  submit: function () {
    const self = this;

    //Get dates either from individual inputs or from term select
    let date_from_value, date_to_value;
    
    const term_select_value = jQuery(self.selectors.input_term_select).val();
    if (term_select_value && term_select_value !== '') {
      // Parse dates from term select (format: "18.09.2025|20.09.2025")
      const dates = term_select_value.split('|');
      if (dates.length === 2) {
        date_from_value = dates[0];
        date_to_value = dates[1];
      } else {
        date_from_value = jQuery(self.selectors.input_date_from).val();
        date_to_value = jQuery(self.selectors.input_date_to).val();
      }
    } else {
      date_from_value = jQuery(self.selectors.input_date_from).val();
      date_to_value = jQuery(self.selectors.input_date_to).val();
    }

    //Checks
    const date_from = moment(date_from_value, "DD.MM.YYYY");
    const date_to = moment(date_to_value, "DD.MM.YYYY");

    const differenceInDays = date_to.diff(date_from, 'days');

    if (isNaN(differenceInDays)) {
      const input_date_from = jQuery(self.selectors.input_date_from)[0];
      input_date_from.setCustomValidity(sikmoVars.translation.reservation.invalid_date);
      input_date_from.reportValidity();
      return;
    }

    if (differenceInDays < 0) {
      const input_date_to = jQuery(self.selectors.input_date_to)[0];
      input_date_to.setCustomValidity(sikmoVars.translation.reservation.invalid_date_to);
      input_date_to.reportValidity();
      return;
    }

    const input_persons = jQuery(self.selectors.input_persons)[0];
    if (input_persons && !input_persons.reportValidity()) {
      return;
    }

    if (self.options.doing_ajax) {
      return;
    }

    self.options.doing_ajax = true;
    jQuery(self.selectors.button_submit).attr("disabled", "disabled");

    jQuery.ajax({
      dataType: "json",
      method: "POST",
      url: self.options.ajax_url,
      data: {
        action: "reservation",
        reservation_action: "create",
        id: jQuery(self.selectors.input_id).val(),
        date_from: date_from_value,
        date_to: date_to_value,
        persons: jQuery(self.selectors.input_persons).val(),
      },
    })
      .done(function (data) {
        if (data.status === "success") {
          window.location.href = data.redirect_url;
        } else if (data.status === "need_login") {
          window.location.href = data.redirect_url;
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        if (jqXHR.responseJSON?.data) {
          jQuery(self.selectors.error).text(jqXHR.responseJSON.data).addClass("show");
        } else {
          jQuery(self.selectors.error).text(sikmoVars.translation.reservation.unexcepted_error).addClass("show");
        }
      })
      .always(function () {
        self.options.doing_ajax = false;
        jQuery(self.selectors.button_submit).removeAttr("disabled");
      });
  },

  boxReCalc: function () {
    const self = this;

    //Get dates either from individual inputs or from term select
    let date_from_value, date_to_value;
    
    const term_select_value = jQuery(self.selectors.input_term_select).val();
    if (term_select_value && term_select_value !== '') {
      // Parse dates from term select (format: "18.09.2025|20.09.2025")
      const dates = term_select_value.split('|');
      if (dates.length === 2) {
        date_from_value = dates[0];
        date_to_value = dates[1];
      } else {
        date_from_value = jQuery(self.selectors.input_date_from).val();
        date_to_value = jQuery(self.selectors.input_date_to).val();
      }
    } else {
      date_from_value = jQuery(self.selectors.input_date_from).val();
      date_to_value = jQuery(self.selectors.input_date_to).val();
    }

    const date_from = moment(date_from_value, "DD.MM.YYYY");
    const date_to = moment(date_to_value, "DD.MM.YYYY");

    const differenceInDays = date_to.diff(date_from, 'days');

    if (!isNaN(differenceInDays) && differenceInDays > 0) {
      let stepper_date = date_from.clone();
      let special_prices = {};
      while (stepper_date.isBefore(date_to)) {
        const current_stepper_date = stepper_date.format("YYYYMMDD"); // Output the date in the desired format

        if (accomodation_next_prices_per_day.hasOwnProperty(current_stepper_date)) {
          let count_special_days = 0;
          if (typeof special_prices[accomodation_next_prices_per_day[current_stepper_date]] !== "undefined") {
            count_special_days = special_prices[accomodation_next_prices_per_day[current_stepper_date]];
          }
          special_prices[accomodation_next_prices_per_day[current_stepper_date]] = count_special_days + 1;
        }
        // Move to the next day
        stepper_date.add(1, 'days');
      }

      //reset
      jQuery(self.selectors.count_box_price_list).html("");

      let price_total = 0;

      let day_translation = sikmoVars.translation.day;
      let days_translation = sikmoVars.translation.days;

      if (jQuery(self.selectors.count_box).data("type") === "accommodation") {
        day_translation = sikmoVars.translation.night;
        days_translation = sikmoVars.translation.nights;
      }

      //Special prices
      let days_with_special_price = 0;
      if (Object.keys(special_prices).length > 0) {
        for (var key in special_prices) {
          if (special_prices.hasOwnProperty(key)) {
            const val = special_prices[key];
            days_with_special_price += val;
            jQuery(self.selectors.count_box_price_list).append(`<li>
              <div>`+ key.toLocaleString() + " " + accomodation_currency + ` x ` + val + " " + (val > 1 ? days_translation : day_translation) + `</div>
              <div>`+ (val * key).toLocaleString() + " " + accomodation_currency + `</div>
            </li>`);

            price_total += val * key;
          }
        }
      }

      const days_without_special_price = differenceInDays - days_with_special_price;
      //Normal price
      if (days_without_special_price > 0) {
        jQuery(self.selectors.count_box_price_list).append(`<li>
          <div>`+ accomodation_default_price_per_day.toLocaleString() + " " + accomodation_currency + ` x ` + days_without_special_price + " " + (days_without_special_price > 1 ? days_translation : day_translation) + `</div>
          <div>`+ (days_without_special_price * accomodation_default_price_per_day).toLocaleString() + " " + accomodation_currency + `</div>
        </li>`);

        price_total += days_without_special_price * accomodation_default_price_per_day;
      }

      //set total price
      jQuery(self.selectors.count_box_price_total).text(price_total.toLocaleString() + " " + accomodation_currency);

      jQuery(self.selectors.count_box).css("display", "block");
    } else {
      jQuery(self.selectors.count_box).css("display", "none");
    }
  }
}

// Export
export { accomodationReservation };